import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';
import { getCurrentUser } from '../services/api';

const LoadingScreen = () => (
  <Box 
    sx={{ 
      height: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      backgroundColor: 'background.default'
    }}
  >
    <CircularProgress />
  </Box>
);

const AuthGuard = ({ children }) => {
  const { user, updateUser } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (!user?.firebaseUser) {
          setLoading(false);
          return;
        }
        const userData = await getCurrentUser();
        updateUser({
          ...user,
          ...userData
        });
      } catch (error) {
        console.error('Failed to fetch user data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [user?.firebaseUser, updateUser]);

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AuthGuard; 